export default {
  "content": "<path d=\"M31.273 17.534l-3.749 2.152-.349 4.31-1.678-1.519-1.526-1.381-4.207 1.003 1.765-3.947-2.245-3.693 4.294.458 1.853-2.16.96-1.119.893 4.231 3.99 1.665z\" fill=\"#D4D5D7\"/><path d=\"M25.431 22.543v8.73H.727V.727h20.061l4.643 4.66v7.371\" stroke=\"#282C36\" stroke-linejoin=\"round\"/><path d=\"M25.279 5.816h-4.934V.742M5.82 9.458h14.533M5.82 13.82h7.986M5.82 18.18h10.892M5.82 22.543h4.36M.734 3.642H20.352M25.431 12.758l.96-1.12.893 4.231 3.99 1.665-3.75 2.152-.349 4.31-1.678-1.519-1.526-1.381-4.207 1.003 1.765-3.947-2.245-3.693 4.294.458 1.853-2.16z\" stroke=\"#282C36\" stroke-linejoin=\"round\"/>",
  "attrs": {
    "width": "32",
    "height": "32",
    "viewBox": "0 0 32 32",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};